/**
 * Lowercase + suppress accents (NFD) so "tele" matches "télécabine".
 */
export function foldSearchText(s: string): string {
  return s
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
}
